import { PageHero, SitePage } from "@/components/SitePage";

export default function Contact() {
  return (
    <SitePage>
      <PageHero
        label="Contact"
        title="Discuss your transformation priorities."
        intro="Share the operating issue, the systems involved and the outcome you need. Our first discussion will focus on the business context and whether Averentia is the right fit."
        aside={<><span>Direct contact</span><a href="mailto:internal@averentia.ai">internal@averentia.ai</a></>}
      >
        <div className="av-actions">
          <a className="av-button av-button-dark" href="https://calendly.com/ritwik-averentia" target="_blank" rel="noreferrer" data-testid="contact-book-cta">
            Schedule a discussion <span aria-hidden="true">↗</span>
          </a>
          <a className="av-text-link" href="mailto:internal@averentia.ai">Email Averentia <span aria-hidden="true">→</span></a>
        </div>
      </PageHero>
      <section className="av-founders" aria-labelledby="av-founders-title">
        <div className="av-shell">
          <div className="av-founders-heading">
            <p className="av-kicker">Founders</p>
            <h2 id="av-founders-title">Meet the founders.</h2>
          </div>
          <div className="av-founder-grid">
            <article className="av-founder-profile">
              <div className="av-founder-photo">
                <img src="/founders/madhav-sainanee.jpg" alt="Madhav Sainanee" />
              </div>
              <div className="av-founder-copy">
                <p className="av-founder-role">Co-founder · Technology</p>
                <h3>Madhav Sainanee</h3>
                <p>Madhav has built production software at Google and Databricks. At Averentia, he leads technical architecture and AI delivery.</p>
                <a href="https://www.linkedin.com/in/madhav-sainanee/" target="_blank" rel="noreferrer" aria-label="Madhav Sainanee on LinkedIn">
                  LinkedIn <span aria-hidden="true">↗</span>
                </a>
              </div>
            </article>
            <article className="av-founder-profile">
              <div className="av-founder-photo">
                <img src="/founders/ritwik-kanodia.jpg" alt="Ritwik Kanodia" />
              </div>
              <div className="av-founder-copy">
                <p className="av-founder-role">Co-founder · Transformation</p>
                <h3>Ritwik Kanodia</h3>
                <p>Ritwik has built enterprise and commerce systems across SAP, Visa and TikTok. At Averentia, he leads client transformation and implementation.</p>
                <a href="https://www.linkedin.com/in/ritwikkanodia/" target="_blank" rel="noreferrer" aria-label="Ritwik Kanodia on LinkedIn">
                  LinkedIn <span aria-hidden="true">↗</span>
                </a>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section className="av-contact-notes">
        <div className="av-shell av-contact-grid">
          <article><span>01</span><h2>Business context</h2><p>The process, service or decision that needs to improve.</p></article>
          <article><span>02</span><h2>Technology context</h2><p>The systems, data and controls involved in the work.</p></article>
          <article><span>03</span><h2>Expected result</h2><p>The operating measure or business outcome that matters.</p></article>
        </div>
      </section>
    </SitePage>
  );
}
